import { load } from "../bot-loaders"

export interface ExtendedTemplate {
    id: number
    campaign: number
    media: number
    message: string
}

export async function loadTemplates(campaign: number){
    var result =  await load("api/extended-templates/" + campaign)
    return result.templates as  ExtendedTemplate[];
}

export async function addTemplate(template: ExtendedTemplate){
    var res =  await load("api/extended-templates/add", template)
    return res.result as  ExtendedTemplate;
}

export async function removeTemplate(template: ExtendedTemplate){
    var res =  await load("api/extended-templates/delete", {id: template.id})
    return res.result as  ExtendedTemplate;
}

export async function updateTemplate(template: ExtendedTemplate){
    var res =  await load("api/extended-templates/update", template)
    return res.result as  ExtendedTemplate;
}